import { PAGE_PATHS } from '@/app/constants/pages';
import { PeriodProvider } from '@/components/context/PeriodContext';
import PeriodInitializer from '@/components/periodDetails/PeriodInitializer';
import AccountingAccount from '@/pages/accountingAccount';
import BranchResultCenter from '@/pages/branchResultCenter';
import DebitNote from '@/pages/debitNotes';
import Events from '@/pages/events';
import Login from '@/pages/login';
import NoSharing from '@/pages/noSharing';
import PersonProductRoles from '@/pages/personProductRoles';
import RuleClassification from '@/pages/ruleClassification';
import Sharing from '@/pages/sharing';
import TeacherPayment from '@/pages/teacherPayment';
import { Route, Routes } from 'react-router-dom';
import PERMISSION_ROLES, { PAGE_NAMES } from '../app/constants/roles';
import RequireAuth from '../features/auth/RequireAuth';
import RequireLogin from '../features/auth/RequireLogin';
import Layout from '../pages/layout';
import PMOSharing from '../pages/pmoSharing';
import Redirect from '../pages/redirecting';

function AppRoute() {
  return (
    <PeriodProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<RequireLogin />}>
          <Route element={<PeriodInitializer />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Redirect />} />
              <Route element={<RequireAuth roles={PERMISSION_ROLES[PAGE_NAMES.CONTROLLERSHIP]} />}>
                <Route path={PAGE_PATHS.PMO} element={<PMOSharing />} />
                <Route path={PAGE_PATHS.TEACHERPAYMENT} element={<TeacherPayment />} />
                <Route path={PAGE_PATHS.EVENTS} element={<Events />} />
                <Route path={PAGE_PATHS.SHARING} element={<Sharing />} />
                <Route path={PAGE_PATHS.ACCOUNTINGACCOUNT} element={<AccountingAccount />} />
                <Route path={PAGE_PATHS.BRANCHRESULTCENTER} element={<BranchResultCenter />} />
                <Route path={PAGE_PATHS.DEBITNOTES} element={<DebitNote />} />
                <Route path={PAGE_PATHS.NOSHARING} element={<NoSharing />} />
                <Route path={PAGE_PATHS.CLASSIFYINCENTIVIZED} element={<RuleClassification />} />
              </Route>
              <Route element={<RequireAuth roles={PERMISSION_ROLES[PAGE_NAMES.ADMIN]} />}>
                <Route path={PAGE_PATHS.PERMISSIONSBYPRODUCTS} element={<PersonProductRoles />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </PeriodProvider>
  );
}

export default AppRoute;
